/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * SHA256 hash for deduplication checks
 */
export type TaskSubmissionVersionDetailContentHash = string | null;
